package com.essntl.features.invoice.ui.addeditinvoice.price

import com.essntl.features.invoice.ui.addeditinvoice.components.sidebar.PriceDetailsUiState
import com.essntl.features.paymentparameter.domain.model.PaymentParameterModel

fun calcTotalPrice(
    servicesPriceDetailsList: List<PriceDetailsUiState>,
    extraServicesPriceDetailsList: List<PriceDetailsUiState>,
): Int {
    // Services Price
    val servicesPrice = servicesPriceDetailsList.sumOfPrice()
    val extraServicesPrice = extraServicesPriceDetailsList.sumOfPrice()
    val servicesTotalPrice = servicesPrice + extraServicesPrice

    return servicesTotalPrice.coerceAtLeast(0)
}

fun applyPaymentParameters(
    servicesTotalPrice: Int,
    paymentParameterList: List<PaymentParameterModel>,
): Int {
    var totalPrice = servicesTotalPrice

    // Apply Payment Parameters

    // Flat Fee
    paymentParameterList
        .filter { it.type == PaymentParameterModel.Type.FlatFee }
        .map {
            it.amount?.let { a ->
                if (it.method == PaymentParameterModel.Method.Add)
                    totalPrice += a
                else
                    totalPrice -= a
            }
        }

    // Percentage
    paymentParameterList
        .filter { it.type == PaymentParameterModel.Type.Percentage }
        .map {
            it.amount?.let { a ->
                val percentage = ((servicesTotalPrice / 10000F) * a).toInt()
                if (it.method == PaymentParameterModel.Method.Add)
                    totalPrice += percentage
                else
                    totalPrice -= percentage
            }
        }

    return totalPrice.coerceAtLeast(0)
}

fun getStripeProducts(
    invoiceDocNumber: String,
    servicesTotalPrice: Int,
    paymentParameterList: List<PaymentParameterModel>,
): List<Pair<String, Int>> {
    val productPriceList = mutableListOf<Pair<String, Int>>()

    // main product
    productPriceList.add(invoiceDocNumber to servicesTotalPrice)

    // Apply selected Payment Parameters

    // Flat Fee
    paymentParameterList
        .filter { it.type == PaymentParameterModel.Type.FlatFee }
        .map {
            it.amount?.let { price ->
                if (it.method == PaymentParameterModel.Method.Add &&
                    it.applyToAmount == false
                ) {
                    productPriceList.add((it.name ?: invoiceDocNumber) to price)
                }
            }
        }

    // Percentage
    paymentParameterList
        .filter { it.type == PaymentParameterModel.Type.Percentage }
        .map {
            it.amount?.let { percentage ->
                if (it.method == PaymentParameterModel.Method.Add &&
                    it.applyToAmount == false
                ) {
                    val price = ((servicesTotalPrice / 10000F) * percentage).toInt()
                    productPriceList.add((it.name ?: invoiceDocNumber) to price)
                }
            }
        }

    return productPriceList.toList()
}

fun List<PriceDetailsUiState>.sumOfPrice(): Int {
    return sumOf { it.price * it.quantity }
}